export default {
	change_password: "Cambiar contraseña",
	control_pannel: "Panel de Control",
	idiom: "Idioma",
	messages: "Mensajes",
	my_profile: "Mi Perfil",
	no_notification_available: "No hay notificación disponible",
	no_notifications_avaliable: "No hay notificaciones disponibles.",
	sign_out: "Salir"
}